import React, { useState } from 'react';
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';
import Button from '../shared/Button';
import Heading from '../shared/Heading';
import { everyDayMeals, promotions, signaturebox, sharing, snacks, midnight } from '../constants';
import ItemCard from '../components/ItemCard';
import { useDispatch, useSelector } from 'react-redux';
import TopBadges from '../components/TopBadges';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';
import { addItemToBucket, removeItemFromBucket, selectTotalCost, selectTotalQuantity } from '../features/bucket/bucketSlice';
import ItemModal from '../components/modals/ItemModal';
import { Link } from 'react-router-dom';

const Menu = () => {
  const [activeLabelButton, setActiveLabelButton] = useState('Everyday Value');

  const buttonLabels = ['Everyday Value', 'Ala-Carte-&-Combos', 'Promotion', 'Signature-Boxes', 'Sharing', 'Snacks-&-Beverages', 'Midnight (Start at 12 am)'];
  const dispatch = useDispatch();

  const handleButtonClick = (buttonLabel) => {
    setActiveLabelButton(buttonLabel);
  };
  const [showDetail, setShowDetail] = useState(false);

  const bucket = useSelector((state) => state.bucket.items);
  const totalCost = useSelector(selectTotalCost);
  const totalQuantity = useSelector(selectTotalQuantity);
  const addToBucket = (data) => {
    dispatch(addItemToBucket(data));
  };
  const removeFromBucket = (data) => {
    dispatch(removeItemFromBucket(data));
  };

  return (
    <div className='py-3 flex flex-col gap-7'>
      <div className="mx-auto flex gap-3 max-w-[80%] overflow-scroll" >
        {buttonLabels.map((label) => (
          <ScrollLink
            to={label.replace(/\s+/g, '-')}
            spy={true}
            smooth={true}
            duration={500}
            key={label}
          >
            <Button
              data={label}
              type={activeLabelButton === label ? 'solid' : 'outlined'}
              styles={`font-semibold text-black border-none text-sm px-3 ${activeLabelButton !== label ? 'bg-white' : ''
                }`}
              onClick={() => handleButtonClick(label)}
            />
          </ScrollLink>
        ))}
      </div>
      <div className='w-full container mx-auto'>
      <div className=" lg:w-[73%] md:w-full">

        <div className="flex flex-col gap-8">
          <div id='Everyday-Value' className='container mx-auto w-full'>
            <Heading data="EVERYDAY VALUE" />
            <div className="flex flex-row flex-wrap gap-8 mt-6">
              {everyDayMeals.map((item) => (
                <div key={item.id} className='lg:w-[30%] sm:w-full md:w-[40%]'>
                  <ItemCard data={item} />
                </div>
              ))}
            </div>
          </div>
          <div id='Ala-Carte-&-Combos' className='container mx-auto w-full'>
            <Heading data="Ala-Carte-&-Combos" />
            <div className="flex flex-row flex-wrap gap-8 mt-6">
              {everyDayMeals.map((item) => (
                <div key={item?.id} className='lg:w-[30%] sm:w-full md:w-[40%]'>
                  <ItemCard data={item} />
                </div>
              ))}
            </div>
          </div>
          <div id='Promotion' className='container mx-auto w-full'>
            <Heading data="Promotion" />
            <div className="flex flex-row flex-wrap gap-8 mt-6">
              {promotions.map((item) => (
                <div key={item?.id} className='lg:w-[30%] sm:w-full md:w-[40%]'>
                  <ItemCard data={item} />
                </div>
              ))}
            </div>
          </div>
          <div id='Signature-Boxes' className='container mx-auto w-full'>
            <Heading data="Signature-Boxes" />
            <div className="flex flex-row flex-wrap gap-8 mt-6">
              {signaturebox.map((item) => (
                <div key={item?.id} className='lg:w-[30%] sm:w-full md:w-[40%]'>
                  <ItemCard data={item} />
                </div>
              ))}
            </div>
          </div>
          <div id='Sharing' className='container mx-auto w-full'>
            <Heading data="Sharing" />
            <div className="flex flex-row flex-wrap gap-8 mt-6">
              {sharing.map((item) => (
                <div key={item?.id} className='lg:w-[30%] sm:w-full md:w-[40%]'>
                  <ItemCard data={item} />
                </div>
              ))}
            </div>
          </div>
          <div id='Snacks-&-Beverages' className='container mx-auto w-full'>
            <Heading data="Snacks-&-Beverages" />
            <div className="flex flex-row flex-wrap gap-8 mt-6">
              {snacks.map((item) => (
                <div key={item?.id} className='lg:w-[30%] sm:w-full md:w-[40%]'>
                  <ItemCard data={item} />
                </div>
              ))}
            </div>
          </div>
          <div id='Midnight (Start at 12 am)' className='container mx-auto w-full'>
            <Heading data="Midnight (Start at 12 am)" />
            <div className="flex flex-row flex-wrap gap-8 mt-6">
              {midnight.map((item) => (
                <div key={item?.id} className='lg:w-[30%] sm:w-full md:w-[40%]'>
                  <ItemCard data={item} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
        <div className="fixed right-10 top-[14vh] w-[27%] md:w-none hidden lg:block">
        <div className='border w-[95%] h-[82vh] bg-white sticky rounded-[15px] ' id="box">
          <TopBadges />
          <h1 className='font-semibold text-2xl px-3'> {totalQuantity} Items Added</h1>
          <hr className='bg-light-secondary h-[4px] my-2' />
          <div className="flex flex-col gap-2 p-2">
            {bucket.map((item) => (
              <div className=''>
                <div className="flex bg-gray-200 w-full gap-4 min-h-10 p-4 rounded-md rounded-b-none shadow-lg items-center">
                  <div className='flex h-full w-[25%]'>
                    <img src={item.image} alt='item' className='h-full w-full' />
                  </div>
                  <div className='flex flex-col gap-2 w-full'>
                    <div className="flex justify-between items-center flex-row">
                      <h2 className='text-md font-semibold'>{item.title}</h2>
                      <h2 className='text-md font-semibold'>Rs. {item.price}</h2>
                    </div>
                    <div className="flex justify-between">
                      <div className="flex w-[100px] justify-between items-center">
                        {item.quantity === 1 && (<RiDeleteBin6Line onClick={() => removeFromBucket(item)} size={24} className='cursor-pointer' />)}
                        {item.quantity > 1 && (<AiOutlineMinus onClick={() => removeFromBucket(item)} className='cursor-pointer' />)}
                        <text>{item.quantity}</text>
                        <AiOutlinePlus onClick={() => addToBucket(item)} className='cursor-pointer' />
                      </div>
                      {/* <Button data="Detail"  styles="p-[8px] text-sm " type="solid"/> */}
                      {(item.addOns) && (
                        <button className='px-4 py-2 gap-2 items-center rounded flex bg-light-secondary text-white font-bold text-sm' onClick={() => setShowDetail(!showDetail)}>Details <IoIosArrowDown className={`${showDetail ? 'rotate-180' : ''}`} size={20} /></button>
                      )}
                    </div>
                  </div>

                </div>
                {showDetail && (
                  <div className="flex flex-col pl-10 py-3 text-sm bg-gray-200 shadow-inner"  >
                    <ul style={{ listStyleType: 'disc' }}>
                      {item?.addOns?.map((addOn) => (
                        <li key={addOn.id} className='text-sm'>{addOn.item.name}</li>
                      ))}
                    </ul>
                  </div>)}

              </div>
            ))}
          </div>
          <div className='flex-end'>
            <Link to="/bucket">
              <div className="flex flex-end">
                <div id="ribbon" className='flex justify-between items-center'>
                  <p>
                    {totalQuantity} Items | Rs {totalCost}
                  </p>
                  <p className='flex font-bold gap-2'>
                    View Bucket <span className='h-7 w-7 rounded-full bg-white flex items-center justify-center font-bold'><IoIosArrowForward color='black' size={20} /></span>
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>

        </div>
        </div>
    </div>
  )
}

export default Menu;